import { MyRoutes } from './router/MyRoutes';

function App() {
  return (
    <div className='layout'>
      <MyRoutes />
    </div>
  );
}

export default App;
